<template>
  <div>
    <router-link tag="div" class="item" v-for="item in list" :key="item.id" :to="'/daka/'+item.id">
      <div class="head-wrap">
        <div class="head">
          <img :src="item.icon" alt="">
        </div>
      </div>
      <div class="border-bottom">
        <div class="name">{{item.name}}</div>
        <div class="spec">{{item.honor}}</div>
      </div>
      <div class="border-bottom status-wrap">
        <div class="status">已关注</div>
      </div>
    </router-link>
    <!-- 没有数据 -->
    <div class="nodata" v-if="list.length === 0 && loaded">
      <img src="~@/common/image/nofollow.png" alt="">
      <p>您还未关注讲师</p>
    </div>
    <loading v-show="!loaded"></loading>
  </div>
</template>

<script>
import Loading from 'components/base/loading/loading.vue'
import {getMyFollow} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  components: {
    Loading
  },
  data() {
    return {
      list: [],
      loaded: false
    }
  },
  created() {
    getMyFollow().then(res => {
      const data = res.data
      if (data && data.code === RES_OK && data.data) {
        this.list = data.data
      }
      this.loaded = true
    })
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .item
    display table
    width 100%
    table-layout fixed
    height size(160)
    >div
      display table-cell
      vertical-align middle
      box-sizing content-box
  .head-wrap
    padding-left size(30)
    padding-right size(20)
    width size(104)
    .head
      width size(104)
      height size(104)
      // border-radius 50%
      overflow hidden
      // background #ddd
      img
        display block
        width 100%
  .status-wrap
    padding 0 size(30)
    width size(120)
  .status
    font-size size(26)
    color #a2a2a2
    text-align center
    line-height size(46)
    border-radius size(23)
    border 1px solid #a2a2a2
  .name,.spec
    overflow hidden
    text-overflow ellipsis
    display -webkit-box
    -webkit-line-clamp 1
    -webkit-box-orient vertical
    word-wrap break-word
    word-break break-all
  .name
    font-size size(30)
    margin-bottom size(20)
    font-weight 800
  .spec
    font-size size(26)
    color #999
  .nodata
    img
      display block
      width percentage(260/750)
      margin size(300) auto 0
    p
      font-size size(32)
      color #999999
      text-align center
      margin-top size(56)
</style>


// WEBPACK FOOTER //
// src/components/personal/follow/index.vue